import React from 'react';
import { Link } from 'react-router-dom';
import { useHOA } from '../contexts/HOAContext';
import { hoaProfile } from '../lib/hoaProfile';
import { Mountain, TreePine, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
    const profile = hoaProfile(useHOA().hoa);
    return (
        <div className="min-h-screen relative overflow-hidden bg-forest-900">
            {/* Background gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-forest-900/80 via-forest-800/60 to-forest-900/90" />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center">
                {/* Icon cluster */}
                <div className="flex items-center gap-3 mb-8">
                    <TreePine className="w-8 h-8 text-forest-400 opacity-60" />
                    <Mountain className="w-14 h-14 text-forest-300" />
                    <TreePine className="w-8 h-8 text-forest-400 opacity-60" />
                </div>

                {/* 404 display */}
                <h1 className="font-display text-8xl md:text-9xl font-bold text-white/10 leading-none mb-2">
                    404
                </h1>
                <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
                    Page Not Found
                </h2>
                <p className="text-cream/60 text-lg max-w-md mb-10">
                    The page you're looking for doesn't exist. It may have been moved or the
                    URL might be incorrect.
                </p>

                {/* Return Home */}
                <Link
                    to="/"
                    className="group flex items-center gap-2.5 px-8 py-3.5 bg-forest-600 hover:bg-forest-500 border border-forest-400/50 hover:border-forest-300/70 text-white font-semibold rounded-xl shadow-xl transition-all duration-200"
                >
                    <ArrowLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
                    Return Home
                </Link>
            </div>

            {/* Footer */}
            <div className="absolute bottom-0 left-0 right-0 z-10 px-8 py-4 border-t border-white/10">
                <div className="max-w-7xl mx-auto text-center text-cream/30 text-xs">
                    © {new Date().getFullYear()} {profile.name}{profile.location ? ` — ${profile.location}` : ''}
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
